
import images from "../images/images.js";
function CheckpointScrollGp({id, modeData,mode}) {

 function handleGoToTravelInfoACB(item) {
   const lowercaseMode = mode.toLowerCase();
   const labelParam = encodeURIComponent(item.label);
    window.location.hash = `/travelInfo/${id}/${lowercaseMode}?label=${labelParam}`;

    
  }

  return (
    <div className="time-travel-modeJourney">
            <div className="checkPointInfo-subtitle">{mode} Travel Journey</div>
            <div className="time-travel-horizontal-scroll">
              {modeData &&
                 modeData.map((item, index) => (
                  <div key={index} className="time-travel-card">
                    <img
                      src={images[item.image]}
                      alt={item.title}
                      className="time-travel-image"
                     onClick={() => handleGoToTravelInfoACB(item)}
                    />
                    <div className="time-travel-label">{item.label}</div>
                    <div className="time-travel-title">{item.title}</div>
                    <div className="time-travel-text">{item.description}</div>
                  </div>
                ))
                }
            </div>
            </div>
  );
}

export  {CheckpointScrollGp};
